<template>
    <v-dialog-old ref="roleDialog" id="clinicMatchDialog">
        <ValidationObserver ref="editRoles">
            <div class="dialog-container" :class="{loading: loading}">
                <fieldset>
                    <legend>Роль</legend>
                    <label>Название</label>
                    <vee-input v-model="role.description" rules="required" />
                </fieldset>
                <vee-fieldset
                    name="rightsAndRoles"
                    :rules="{requiredPermissions: (role.permissions.length === 0) }"
                    fieldsetClass="rightsAndRoles"
                >
                    <legend>Права роли</legend>
                    <div id="rights" required>
                        <template v-for="permission in availablePermissions">
                            <permission :permission="permission" v-model="role.permissions" :key="permission.permissions"></permission>
                        </template>
                    </div>
                </vee-fieldset>
            </div>
        </ValidationObserver>
        <template v-slot:footer>
            <div class="buttons">
                <template>
                    <button class="green" @click.stop.prevent="saveRole" type="submit">{{ role.id ? 'Сохранить' : 'Создать новую' }}</button>
                </template>
<!--                <button class="orange"  v-if="role.id" @click="deleteRole">Удалить</button>-->
            </div>
        </template>
    </v-dialog-old>
</template>

<script>
import Vue from 'vue';
import {Role} from '@models/parser/Role.js';

import Permission from '@components/common/Permission.vue';
export default {
    props: {
        permissions: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            role: new Role(),
            map: null,
            showAlterLinks: false,
            loading: false
        }
    },
    components: {
        'permission': Permission,
    },
    computed: {
        availablePermissions () {
            if (this.permissions[this.role.guard] !== undefined) {
                return this.permissions[this.role.guard];
            }
            return [];
        }
    },
    methods: {
        show: function (role) {
            this.loading = true;
            let promise = this.axios.post('roles/' + role.id + '/read');
            promise.then((response) => {
                    this.loading = false;
                    Vue.set(this, 'role', new Role(response.data.data));

                    this.$refs.roleDialog.show()
                        .then(() => {
                            this.$emit('shown', {roleId: this.role.id})
                        });
                });
            return promise;
        },

        saveRole: function () {
            this.loading = true;
            let url = '';
            if (this.role.id) {
                url = 'roles/' + this.role.id + '/update';
            } else {
                url = 'roles/create';
            }
            let flattenFunction = function (elements) {
                let arrays = elements.map((item) => {
                    let result = [];
                    if (item.inner) {
                        result = flattenFunction(item.inner);
                    }
                    result.push(item.permissions);
                    return result;
                });
                return arrays.flat(Infinity);
            }
            let availableKeys = flattenFunction(this.availablePermissions);
            this.role.permissions = this.role.permissions.filter((item) => {
                let exists = availableKeys.find((avail) => {
                    if (avail === item) {
                        return true;
                    }
                });
                if (exists) {
                    return true;
                }
                return false;
            });
            this.$refs.editRoles.validate().then(success => {
                if (!success) {
                    const el = document.querySelector(".hasError:first-of-type");
                    this.loading = false;
                    el.scrollIntoView({behavior: "smooth"});
                    return;
                }
                this.axios.post(url, this.role)
                    .then((response) => {
                        this.loading = false;
                        Vue.set(this, 'role', new Role(response.data));
                        this.hide();
                    })
            });

        },
        deleteRole () {
            this.$modal('Удалить роль?', {
                callback: (e) => {
                    this.loading = true;
                    this.axios.post('roles/' + this.role.id + '/delete')
                        .then((response) => {
                            this.loading = false;
                            Vue.set(this, 'role', new Role());
                            this.hide();

                        })
                },
            }, {
                callback () {

                }
            });
        },

        createRole () {
            this.role = new Role();
            this.$refs.roleDialog.show()
                .then(() => {
                    this.$emit('shown', {roleId: this.role.id})
                });
        },

        hide () {
            this.$refs.roleDialog.hide();
            this.$emit('closed', {roleId: this.role.id});
        }
    }
}
</script>
<style>
#clinicMatchDialog {
    width: 70%;
}
</style>
<style scoped lang="scss">

.buttons {
    display: flex;

    .left {
        button[type=submit] {
            border-width: 1px !important;
        }
    }

    .right {
        flex: 1 0;
        align-content: flex-end;
        text-align: right;
    }
}

.image {
    display: inline-block;
    width: 152px;
    height: 152px;

    img {
        border: 1px solid lightgrey;
        max-width: 150px;
        max-height: 150px;
    }
}

.clinic-block, .clinic {
    display: grid;
    grid-template: "image image" "name deleted" "address fullfill" "sites fullfill";

    .image {
        grid-area: image;
    }

    .name {
        grid-area: name;
    }

    .address {
        grid-area: address;
    }

    .sites {
        grid-area: sites;

        max-width: 40vw;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .fullfill {
        grid-area: fullfill;
    }

}

.clinic-block {
    margin: 15px 0;
    padding: 5px;

    border: 1px solid lightgrey;
    cursor: pointer;

    grid-template: "image name deleted" "image address fullfill" "image sites fullfill";
    grid-template-columns: auto 1fr 100px;

    &:hover {
        background: #f3f2f2;
    }

    .image {
        width: auto;
        img {
            width: 80px;
            margin-right: 15px
        }
    }
}
</style>
